import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DosageAddComponent } from './dosage-add.component';
import {
  MatExpansionModule, MatDatepickerModule,
  MatSelectModule, MatFormFieldModule, MatNativeDateModule, MatInputModule, MAT_DATE_LOCALE
} from '@angular/material';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  imports: [
    CommonModule, FormsModule, IonicModule, MatExpansionModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule
  ],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ],
  declarations: [DosageAddComponent],
  exports: [DosageAddComponent]
})
export class DosageAddModule { }
